module.exports = __webpack_public_path__ + "static/main-placeholder-5982440d4f0d729766f5941b71480d5f.jpg";